import {
  get,
  post,
  patch
} from './http';

export const http = {
  register: function(params) {
    return post('/api/user/register', params)
  },
  login: function(params) {
    return post('/api/user/web-login', params)
  },
  resetPwd: function(params) {
    return post('/api/user/reset-password', params)
  },
  getLoginCatpcha: function(params) {
    return get('/api/public/get-login-captcha', params)
  },
  departmentList: function(page, size) {
    return get('/api/department/list', {
      page,
      size
    });
  },
  groupServiceList: function(params) {
    return get('/api/service/group-list', params)
  },
  doorCateList: function(params) {
    return get('/api/info-category/list', params)
  },
  getSetList: function(params) {
    return get('/api/setting/list', params)
  },
  latestServices: function(params) {
    return get('/api/service/list?sort=order&sort_type=ASC&size=12&published=1', params)
  },
  hotServices: function(params) {
    return get('/api/service/list?sort=apply_count&sort_type=DESC&size=12&published=1', params)
  },
  sendPhone: function(params) {
    return post('/api/public/send-captcha', params)
  },
  readCopy: function(params) {
    return post('/api/personal-center/copy-read', params)
  },
  allServices: function(params) {
    return get('/api/service/all', params)
  },
  applyService: function(serviceId) {
    return post('/api/service/apply', {
      service_id: serviceId
    });
  },
  deleteServiceApply: function(serviceapplyId) {
    return post('/api/service-apply/delete', {
      service_apply_id: serviceapplyId
    });
  },
  //根据节点获取某个服务，service_apply_id或node_run_id 二选一
  getServiceApply: function(params) {
    return get('/api/personal-center/apply-get', params);
  },
  getService: function(params) {
    return get('/api/service/get', params);
  },
  userList: function(page, size, mobile, name) {
    return get('/api/user/list', {
      page,
      size,
      mobile,
      name
    });
  },
  allUser: function() {
    return get('/api/user/all');
  },
  //领取任务
  claimNode: function(node_run_id) {
    return post('/api/personal-center/claim', {
      node_run_id
    });
  },
  //提交运行节点
  //formFields表单数据，例如[{"id":"11","value":"陈先生"}]，ID字段ID，value填写内容
  doNodeRun: function(nodeRunId, status, note, formFields, copyToUserIds) {
    return post('/api/personal-center/run', {
      node_run_id: nodeRunId,
      status: status,
      note: note,
      form_fields: formFields,
      copy_to_user_ids: copyToUserIds
    });
  },
  saveNodeFormData: function(nodeRunId, formFields) {
    return post('/api/personal-center/save-form-data', {
      node_run_id: nodeRunId,
      form_fields: formFields
    });
  },
  listChildNodes: function(node_run_id) {
    return get('/api/personal-center/list-child-nodes', {
      node_run_id
    });
  },
  createChildNode: function(node_run_id, user_id, title, deadline, forms) {
    return post('/api/personal-center/create-child-node', {
      node_run_id,
      user_id,
      title,
      deadline,
      forms
    });
  },
  updateChildNode: function(node_run_id, title, deadline, forms) {
    return post('/api/personal-center/update-child-node', {
      node_run_id,
      title,
      deadline,
      forms
    })
  },
  //删除子节点
  deleteChildNode: function(node_run_id) {
    return post('/api/personal-center/delete-child-node', {
      node_run_id
    });
  },
  //待办事项
  todoNodeList: function(page, size) {
    return get('/api/personal-center/todo-node-list', {
      page,
      size
    });
  },
  finishedNodeList: function(page, size) {
    return get('/api/personal-center/finished-node-list', {
      page,
      size
    });
  },
  filesList: function(page, size) {
    return get('/api/personal-center/files-list', {
      page,
      size
    });
  },
  //我申请的事项
  applyList: function(page, size, service_id) {
    return get('/api/personal-center/apply-list', {
      page,
      size,
      service_id
    });
  },
  //我审核的事项
  auditList: function(page, size) {
    return get('/api/personal-center/audit-node-list', {
      page,
      size
    });
  },
  //抄送给我的事项
  copyList: function(page, size) {
    return get('/api/personal-center/copy-node-list', {
      page,
      size
    });
  },
  //提交任务
  submitChildNode: function(node_run_id, content, form_fields) {
    return post('/api/personal-center/submit-child-node', {
      node_run_id,
      content,
      form_fields
    });
  },
  auditChildNode: function(node_run_id, status, note) {
    return post('/api/personal-center/audit-child-node', {
      node_run_id,
      status,
      note
    });
  },
  getWkNodeRun: function(id) {
    return get('/api/wk-node-run/get', {
      id
    });
  },
  listTables: function(page, size) {
    return get('/api/table/list', {
      page,
      size
    });
  },
  listNodeTables: function(node_run_id) {
    return get('/api/table/list-node-tables', {
      node_run_id
    });
  },
  saveForm: function(form_run_id, value) {
    return post('/api/wk-form-run/save', {
      form_run_id,
      value
    });
  },
  userData: function() {
    return get('/api/personal-center/user-data', {});
  },
  loadDataFromApply: function(table_id, node_run_id) {
    return get('/api/wk-form-run/load-data-from-apply', {
      table_id,
      node_run_id
    })
  },
  getMaterialByCode(code) {
    return get('/api/material/get-by-code', {
      code
    });
  },
  checkStockNumber(codes) {
    return post('/api/material/check-stock-number', {
      codes
    })
  },
  //上传文件
  addFile(name, url) {
    return post('/api/files/add', {
      name,
      url
    })
  },
  doAction(action_id) {
    return post('/api/personal-center/do-action', {
      action_id
    });
  },
  getServiceApplyNodeTree(service_apply_id) {
    return get('/api/service-apply/get-node-tree', {
      service_apply_id
    });
  },
  getAllServiceGroups() {
    return get('/api/service-group/all-groups', {});
  }
}



// WEBPACK FOOTER //
// ./src/request/api.js